// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loader_spinner__AGBCl","sk-bouncedelay":"Loader_sk-bouncedelay__2TR5z","bounce1":"Loader_bounce1__1DUaW","bounce2":"Loader_bounce2__2-AIW"};